import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';

export type Resource = { prefix: string; suffix: string };

export class MultiTranslateHttpLoaderService implements TranslateLoader {
    public constructor(
        private readonly http: HttpClient,
        private resources: Resource[],
    ) {}

    public getTranslation(lang: string): Observable<Record<string, unknown>> {
        return forkJoin(
            this.resources.map((config: Resource) =>
                this.http.get<Record<string, unknown>>(`${config.prefix}${lang}${config.suffix}`),
            ),
        ).pipe(
            map((responses: Array<Record<string, unknown>>) => {
                const mergeResult = {};
                _.merge(mergeResult, ...responses);
                return mergeResult;
            }),
        );
    }
}
